//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Features',
  props: {
    image: {
      type: Object,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    features: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: '#4f4d4d' // fallback is defined in graphql api, but put here to be clear
    },
    textColor: {
      type: String,
      default: '#ffffff' // fallback is defined in graphql api, but put here to be clear
    }
  },
  data() {
    return {
      // set this to true if you don't want the image to auto-crop on wide screens
      contain: false
    };
  },
  computed: {
    mobileAndPhablet() {
      return this.$mq === 'mobile' || this.$mq === 'phablet';
    },
    rootStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    },
    textStyle() {
      return {
        color: this.textColor
      };
    }
  }
};
